import { useEffect, useState, lazy, Suspense } from "react";
import { useAppState } from "../../context";
import { ReviewType } from "../../types";
import { fetchJson } from "../../utils";

// Lazy load the Swiper component
const ReviewSwiper = lazy(() => import('./ReviewSwiper'));

export const ReviewBlock = () => {
    const [reviews, setReviews] = useAppState<ReviewType[]>("reviews", []);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
        
        const fetchReviews = async () => {
            const {json} = await fetchJson<ReviewType[]>("/api/reviews");
            setReviews(Array.isArray(json) ? json : []);
        };

        fetchReviews();
    }, []);

    if (!Array.isArray(reviews) || reviews.length === 0) {
        return null;
    }

    return <section className="section s-fback">
        <div className="inside-wrapper">
            <h2 className="section__title">
                What Our Clients Say
            </h2>
            {isClient ? (
                <Suspense fallback={<div>Loading...</div>}>
                    <ReviewSwiper reviews={reviews} />
                </Suspense>
            ) : (
                // Fallback for SSR
                <div className="s-fback__slider">
                    {reviews.map((review, idx) => (
                        <div className="s-fback__slide" key={idx}>
                            <div className="feedback">
                                <div className="feedback__head">
                                    <picture className="feedback__ava">
                                        <img className="feedback__ava-img" src={`/api/media/${review.avatar}`} alt="" loading="lazy"/>
                                    </picture>
                                    <div className="feedback__stars">
                                        <div className="stars" style={{ '--stars': review.rating } as React.CSSProperties}></div>
                                    </div>
                                </div>
                                <div className="feedback__body">
                                    <div className="feedback__text">
                                        {review.content.split(/\n{2,}/).map((paragraph, index) => (
                                            <p key={index}>{paragraph.split(/\n/).join('<br />')}</p>
                                        ))}
                                    </div>
                                    <div className="feedback__author">
                                        <div className="feedback__author-name">
                                            {review.author}
                                        </div>
                                        <div className="feedback__author-pisition">
                                            {review.post}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            
            <div className="slider__pagination swiper-pagination"></div>
            <div className="slider__controls slider__controls_alt">
                <button className="slider__arrow slider__arrow_prev"></button>
                <button className="slider__arrow slider__arrow_next"></button>
            </div>
        </div>
    </section>
}

export default ReviewBlock;
